module.exports = __webpack_public_path__ + "front/img/gift_wechat.1cd26cac.png";